'use strict';

var debounce = require('lodash/debounce');

/**
 * Handles actions to perform whenever the browser URL changes.
 */
function onLanguageUrlChange() {
    $('.main-header-component .country-selector a').each(function () {
        const baseUrl = $(this).attr('href');
        if (!baseUrl) return;
        const basePath = baseUrl.split('?')[0];
        $(this).attr('href', basePath + window.location.search);
    });
}

const mainHeader = {
    init: function () {
        const $window = $(window);
        const $body = $('body');
        const $expHeader = $('.experience-header');
        let lastScrollTop = $window.scrollTop();

        // Updating header and shop note height in css variables
        const $header = $('.experience-commerce_assets-mainHeader');

        let $searchResults = $('.search-results').first();
        let stickyOffset = 0;

        if ($searchResults.length) {
            stickyOffset = $searchResults.offset().top;

            $(document).on('shopnoteclose', function () {
                stickyOffset = $searchResults.offset().top;
            });

            $window.on('orientationchange', function () {
                stickyOffset = $searchResults.offset().top;
            });
        }

        // Detect scroll event
        $window.on(
            'scroll',
            debounce(function () {
                const currentScroll = $window.scrollTop();
                const headerHeight = $('.main-header-component').height() || 0;
                $expHeader.toggleClass('hide-header', $window.scrollTop() > $header.outerHeight() && !$('nav').hasClass('menu-active'));
                $('.minicart-overlay-wrapper').toggleClass('hide-header', $window.scrollTop() > $header.outerHeight());
                const isScrollDown = currentScroll > lastScrollTop;
                $body.toggleClass('scroll-up squeezed-header', !isScrollDown);
                $expHeader.toggleClass('squeezed-header', !isScrollDown);
                if (currentScroll === 0) {
                    $body.addClass('show-logo');
                    $body.removeClass('squeezed-header');
                    $expHeader.removeClass('squeezed-header');
                } else {
                    $body.removeClass('show-logo');
                }
                lastScrollTop = currentScroll;
                if ($searchResults.length && !$body.hasClass('filter-open')) {
                    $body.toggleClass('sticky-filter-active', currentScroll >= stickyOffset - headerHeight && !$('.suggestions').length);
                }
            }, 50)
        );

        $window.on(
            'load orientationchange resize',
            debounce(function () {
                // Updating header and shop note height in css variables
                const $topStrip = $('.experience-commerce_assets-shopNote');
                $body.css('--header-height', $header.height() + 'px');
                $body.css('--shop-note-height', $topStrip.is(':visible') ? $topStrip.height() + 'px' : '0px');
            }, 250)
        );

        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        window.history.pushState = function () {
            originalPushState.apply(this, arguments);
            onLanguageUrlChange();
        };

        window.history.replaceState = function () {
            originalReplaceState.apply(this, arguments);
            onLanguageUrlChange();
        };

        window.addEventListener('popstate', onLanguageUrlChange);
        onLanguageUrlChange();
    },
};

module.exports = mainHeader;
